import { AxiosResponse } from 'axios';
import KrpTechopsAdminResource from '@/api/resource/KrpTechopsAdminResource';
import { Envelope } from '@/types/envelope';
import { ResourcePagingOptions } from '@/api/resource/ResourcePagingOptions';
import { DailyLoadFilter } from './DailyLoadFilter';

export class DailyLoadFiStatusResource extends KrpTechopsAdminResource {
  public async getPage(filter : DailyLoadFilter, paging: ResourcePagingOptions): Promise<Envelope> {
    const url: string = `/api/krp/admin/daily-load-status${DailyLoadFiStatusResource.getPageSortingParams(paging)}`;
    const response: AxiosResponse = await this.apiClient.post(url, filter);
    const envelope: Envelope = response.data;
    return envelope;
  }

  static getPageSortingParams(paging: ResourcePagingOptions) : string {
    return `?pageSize=${paging.pageSize}`
      + `&pageIndex=${paging.pageIndex}`
      + `&pageSortColumn=${paging.pageSortColumn}`
      + `&pageSortDirection=${paging.pageSortDirection}`;
  }
}

export default DailyLoadFiStatusResource;
